import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router";
import { panelArr } from "../assets/cultivatorsEventPanels";
import CardsGrid from "../components/CardsGrid";
import Loading from "../components/Loading";
import MarkDown from "../components/MarkDown";
import useEventSeries from "../hooks/useEventSeries";
import Image from "../components/Image";
import structuredData from "../assets/structuredText";

const EventSeries = () => {
  const { eventSeriesID } = useParams();
  const { series, isLoading } = useEventSeries(eventSeriesID || "");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="keywords"
          content="event event-series cultivators lisbon cultiv portugal Forum"
        />
        <meta name="description" content="Event-series that is organized and funded by cultiv" />
        <meta name="robots" content="index, follow" />
        <meta property="og:url" content="https://cultiv.llc" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          itemProp="image"
          content="https://cultiv.llc/images/metaimg.jpg"
        />
        <link
          rel="image_src"
          itemProp="image"
          href="https://cultiv.llc/images/metaimg.jpg"
        />
        <meta
          property="og:description"
          content="Event-series that is organized and funded by cultiv"
        />
        <meta property="og:site_name" content="Cultiv LLC" />
        <meta property="og:title" content="Cultiv | EventSeries" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://cultiv.llc" />
        <meta property="twitter:title" content="Cultiv | EventSeries" />
        <meta
          property="twitter:description"
          content="Event-series that is organized and funded by cultiv"
        />
        <meta
          property="twitter:image"
          content="https://cultiv.llc/images/metaimg.jpg"
        />
        <link rel="canonical" href="https://cultiv.llc" />
        <script type="application/ld+json">{structuredData}</script>
        <title>{series?.title}</title>
      </Helmet>
      {isLoading ? (
        <div className="flex justify-center items-center h-0 min-h-screen">
          <Loading />
        </div>
      ) : (
        <div className="w-full h-full flex flex-col gap-5 justify-center items-center">
          <Image
            className="object-cover w-full min-h-[140px] bg-black xl:min-h-[200px]"
            src={"/images/cultivators/event-series-cover.svg"}
            alt="Cultivators Cover"
          />
          <div className="w-full flex flex-col gap-6 xl:gap-10 px-6 lg:px-30">
            <div className="flex flex-col w-full gap-3 lg:gap-6">
              <h2 className="font-bold text-xl lg:text-4xl lg:pt-5">{series?.title}</h2>
              <MarkDown
                proseHeaders="prose-headings:m-3"
                proseLead="prose-lead:leading-none"
                proseList="prose-ul:list-disc"
                prosePadding="pr-8"
                articleBody={series?.md_text as string}
              />
            </div>
            <div>
              <h2 className="font-bold text-xl lg:text-4xl pb-3 lg:pb-6">Panels</h2>
              <CardsGrid cards={panelArr} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EventSeries;
